import type { MiceColor } from '@voll-intelligence/domain';
import { t } from '@web/i18n';
import { Dot } from '@web/ui/core';

/** O tom de cada cor da recomendação (o amarelo é o `amber` dos tons). */
export const COLOR_TONE = { green: 'green', yellow: 'amber', red: 'red' } as const satisfies Record<
  MiceColor,
  string
>;

/** O ponto de cor da recomendação; sem cor (recomendação antiga), nada. */
export function ColorDot({ color }: Readonly<{ color: MiceColor | null }>) {
  if (color === null) return null;
  return (
    <Dot
      tone={COLOR_TONE[color]}
      size="md"
      role="img"
      aria-hidden={false}
      aria-label={t(`mice.color.${color}`)}
    />
  );
}
